module.exports = __webpack_public_path__ + "ru-card-icon.png?336c41be4d5c5e636645852276e7772e";